import React, { createContext, useState, useContext } from "react";
import dayjs from "dayjs";

import useAccountingData from "../hooks/accountingData";
import { useDisplayEvents } from "../components/events";

const PurchasingContext = createContext();

export const PurchasingContextProvider = ({ children }) => {
  const [{ accountingYears = [] }, accountingDataLoading] = useAccountingData();
  const [events, eventsLoading] = useDisplayEvents();

  const [attributionYear, setAttributionYear] = useState(
    dayjs().month() < 3 ? dayjs().year() - 1 : dayjs().year()
  );
  const [selectedScopeChips, setSelectedScopeChips] = useState([]);
  const [purchaseTons, setPurchaseTons] = useState(0);
  const [purchaseDollars, setPurchaseDollars] = useState(0);
  const [selectedTab, setSelectedTab] = useState("volume");
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [inputError, setInputError] = useState(false);
  const [purchaseMode, setPurchaseMode] = useState("one-time");
  const [budgetDollars, setBudgetDollars] = useState(0);
  const [frequency, setFrequency] = useState("monthly");
  const [firstChargeDate, setFirstChargeDate] = useState(null);

  const nonDiamondYears = accountingYears.filter(
    ({ badge }) => badge !== "diamond"
  );
  const diamondYears = accountingYears.filter(
    ({ badge }) => badge === "diamond"
  );
  const eventsThatCanBeOffset = events.filter(
    ({ status }) => status === "closed"
  );

  return (
    <PurchasingContext.Provider
      value={{
        attributionYear,
        setAttributionYear,
        selectedEvents,
        setSelectedEvents,
        selectedScopeChips,
        setSelectedScopeChips,
        purchaseTons,
        setPurchaseTons,
        purchaseDollars,
        setPurchaseDollars,
        selectedTab,
        setSelectedTab,
        nonDiamondYears,
        diamondYears,
        eventsThatCanBeOffset,
        dataLoading: accountingDataLoading || eventsLoading,
        inputError,
        setInputError,
        purchaseMode,
        setPurchaseMode,
        budgetDollars,
        setBudgetDollars,
        frequency,
        setFrequency,
        firstChargeDate,
        setFirstChargeDate,
      }}
    >
      {children}
    </PurchasingContext.Provider>
  );
};

const usePurchasingContext = () => useContext(PurchasingContext);
export default usePurchasingContext;
